import { Modal, Button, Row, Col, Typography, Space } from "antd";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import userSelectors from "../../store/user/selectors";
import { userActions } from "../../store/user";

const { Title, Paragraph, Text } = Typography;

const WelcomeModal = () => {
  const user = useAppSelector(userSelectors.getUserDetails);
  const WelcomeModalvisible = useAppSelector(userSelectors.WelcomeModal);
  const dispatch = useAppDispatch();
  const isReferralUser = !!user?.referred_by;

  return (
    <Modal
      title="🎉 Welcome to HaveTo!"
      visible={WelcomeModalvisible}
      centered
      onCancel={() => {
        dispatch(userActions.welcomeModal({ visible: false }));
      }}
      footer={null}
      width={600}
    >
      <Typography style={{ padding: "0 8px", textAlign: "center" }}>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {isReferralUser ? (
            <>
              <Paragraph>
                👋 Hey <Text strong>{user?.first_name || "there"}</Text>,
                welcome aboard! You’ve joined <Text>through a referral</Text>{" "}
                from{" "}
                <Text strong underline>
                  {user?.referred_by?.email}
                </Text>
              </Paragraph>
              <Paragraph>
                🎁 As a reward, you’ll receive
                <Text strong>1 HVT token</Text> worth $8 USD shortly!
              </Paragraph>
              <Paragraph>
                Keep the chain going — invite your friends and earn more rewards
                together. 🚀
              </Paragraph>
            </>
          ) : (
            <>
              <Paragraph>
                👋 Hey <Text strong>{user?.first_name || "there"}</Text>,
                welcome to <Text strong>HaveTo</Text>! We’re excited to have you
                with us.
              </Paragraph>
              <Paragraph>
                Start exploring the dashboard, and don’t forget — the more
                friends you bring in, the more <Text strong>HVT rewards</Text>{" "}
                you earn. 💎
              </Paragraph>
            </>
          )}
        </Space>
        <Row justify="space-between" gutter={12} style={{ marginTop: 24 }}>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="welcome-btn"
              block
              type="primary"
              onClick={() => {
                dispatch(userActions.welcomeModal({ visible: false }));
              }}
            >
              Go To Dashboard
            </Button>
          </Col>
        </Row>
      </Typography>
    </Modal>
  );
};

export default WelcomeModal;
